import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12770a6c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=12770a6c&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=12770a6c&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=12770a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports